import { api, apiUrl, resolveTenantSlug, tokens } from './api';

// ---------- downloads ----------
export interface SchoolDocument { id: string; title: string; category: string; fileName: string; sizeBytes: number; academicClassId: string | null; isPublished: boolean; createdAt: string; }

export const downloadsApi = {
  list: () => api.get<SchoolDocument[]>('/api/downloads'),
  setPublished: (id: string, on: boolean) => api.post<SchoolDocument>(`/api/downloads/${id}/published/${on ? 'on' : 'off'}`),
  remove: (id: string) => api.del<void>(`/api/downloads/${id}`),
  upload: async (file: File, title: string, category: string, academicClassId: string | null) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('title', title);
    fd.append('category', category);
    if (academicClassId) fd.append('academicClassId', academicClassId);
    const slug = resolveTenantSlug();
    const res = await fetch(apiUrl('/api/downloads'), {
      method: 'POST',
      headers: { ...(slug ? { 'X-Tenant': slug } : {}), ...(tokens.access() ? { Authorization: `Bearer ${tokens.access()}` } : {}) },
      body: fd,
    });
    if (!res.ok) throw new Error('Upload failed');
    return res.json() as Promise<SchoolDocument>;
  },
};

// download a file (admin or family scope), triggering a browser save
export async function downloadFile(scope: 'admin' | 'portal', id: string, fileName: string) {
  const path = scope === 'admin' ? `/api/downloads/${id}/file` : `/api/portal/downloads/${id}/file`;
  const slug = resolveTenantSlug();
  const res = await fetch(apiUrl(path), {
    headers: { ...(slug ? { 'X-Tenant': slug } : {}), ...(tokens.access() ? { Authorization: `Bearer ${tokens.access()}` } : {}) },
  });
  if (!res.ok) throw new Error('Download failed');
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = fileName; a.click();
  URL.revokeObjectURL(url);
}

// ---------- remarks ----------
export interface Remark { id: string; studentId: string; kind: string; note: string; staffOnly: boolean; authorName: string; createdAt: string; }

export const remarksApi = {
  forStudent: (studentId: string) => api.get<Remark[]>(`/api/remarks/student/${studentId}`),
  create: (b: { studentId: string; kind: string; note: string; staffOnly: boolean }) => api.post<Remark>('/api/remarks', b),
  remove: (id: string) => api.del<void>(`/api/remarks/${id}`),
};

export const REMARK_KINDS = ['Appreciation', 'Academic', 'Behaviour', 'Concern', 'General'];
